<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card>
          <div
            slot="header"
            style="display:flex; justify-content: space-between; align-items: center;"
          >
            <HeaderTitle title="Choose Model"></HeaderTitle>
            <b-form-input
              style="display:inline-block; width:250px;float:right"
              v-model="searchQuery"
              type="search"
              id="filterInput"
              placeholder="Type to Search"
            ></b-form-input>
          </div>
          <b-row style="margin-bottom:15px;">
            <b-button-group size="lg" class="mybtns">
              <b-button
                v-for="(btn, idx) in buttons"
                style="margin:2px; border-radius:0 !important; box-shadow:2px 2px black; font-weight:600"
                :key="idx"
                @click="changeView(btn.caption)"
                variant="primary"
              >
                {{ btn.caption }}
              </b-button>
            </b-button-group>
          </b-row>
          <b-row class="message_container">
            <p v-if="message !== ''">{{ message }}</p>
          </b-row>
          <b-row>
            <LoadingCard v-if="loadingData"></LoadingCard>
            <template v-else>
              <b-col
                v-for="model in filterItems(models)"
                lg="3"
                sm="6"
                :key="model.fns_part"
                style="padding: 5px;"
              >
                <a
                  class="locationLabels"
                  :href="'#/model/?part=' + model.fns_part"
                  >{{ model.model }}
                  <span v-if="model.backlog != 0" style="color:yellow">{{
                    model.backlog
                  }}</span></a
                >
              </b-col>
            </template>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import HeaderTitle from "../../../components/shared/HeaderTitle.vue";
import LoadingCard from "../../../components/shared/LoadingCard.vue";

export default {
  name: "AnalyticsByModel",
  data() {
    return {
      buttons: [
        { caption: "Fiber Gear" },
        { caption: "Line Gear" },
        { caption: "Power Supply" },
        { caption: "Transponder" },
        { caption: "Meter" },
        { caption: "Headend" }
      ],
      title: "",
      models: [],
      searchQuery: "",
      loadingData: false,
      message: ""
    };
  },
  methods: {
    changeView(value) {
      this.loadingData = true;
      this.message = "";
      this.title = value;
      let params = {};
      params = {
        type: value
      };
      this.$http.get("api/sercomm/products/modelsByGroup.php", { params }).then(
        res => {
          if (res && res.data && res.data.length > 0) {
            this.models = res.data;
            this.message = "";
          } else {
            this.message = "Pick a Category";
            this.models = [];
          }
          this.loadingData = false;
        },
        err => {
          this.loadingData = false;
          console.log(err);
        }
      );
    },
    filterItems: function(models) {
      var app = this;
      return models.filter(function(models) {
        let regex = new RegExp("(" + app.searchQuery + ")", "i");
        return models.model.match(regex);
      });
    }
  },
  mounted() {
    this.changeView("Power Supply");
  },
  components: { LoadingCard, HeaderTitle }
};
</script>

<style>
.message_container {
  display: flex;
  justify-content: center;
}
.mybtns {
  display: block !important;
  margin: auto;
}
.locationLabels {
  padding: 9px;
}
.loading {
  display: block !important;
  margin: auto !important;
}
</style>
